import React from "react";
import { Typography, Box } from "@mui/material";

//　レベルの詳細
export const LevelTooltipText = ({
  fontSize = 12,
  color = "inherit",
  direction = "column", // column なら縦、row なら横並び
  sx = {},
}) => (
  <Box
    sx={{
      display: "flex",
      flexWrap: "wrap",
      fontSize,
      color,
      flexDirection: direction,
      ...sx,
    }}
  >
    <Typography component="span" variant="inherit">
      【S】テックリード／アーキテクト
    </Typography>
    <Typography component="span" variant="inherit">
      【A】レビュー可能
    </Typography>
    <Typography component="span" variant="inherit">
      【B】独自遂行
    </Typography>
    <Typography component="span" variant="inherit">
      【C】サポート下で遂行
    </Typography>
    <Typography component="span" variant="inherit">
      【D】OJT要
    </Typography>
  </Box>
);

// レベル数値をA-Eに変換するマップ
export const levelMap = {
  5: "S",
  4: "A",
  3: "B",
  2: "C",
  1: "D",
};
